module.exports = __webpack_public_path__ + "static/media/linkedin-icon.d492efc7.png";